import React from 'react';

const CPUNodes1 = (props) => {
  const { svgClass, pathClass, width, height } = props;
  
  return (
    <svg id="Layer_2" className={svgClass} width={width} height={height} data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 51.16">
      <g id="Calque_1" data-name="Calque 1">
        <g>
          <path className={pathClass}
                d="m11.44,32.4h14.84c3.3,0,5.98-2.68,5.98-5.98v-14.84c0-3.3-2.68-5.98-5.98-5.98h-14.84c-3.3,0-5.98,2.68-5.98,5.98v14.84c0,3.3,2.68,5.98,5.98,5.98Zm-4.08-5.98v-14.84c0-2.25,1.83-4.08,4.08-4.08h14.84c2.25,0,4.08,1.83,4.08,4.08v14.84c0,2.25-1.83,4.08-4.08,4.08h-14.84c-2.25,0-4.08-1.83-4.08-4.08Z"/>
          <path className={pathClass}
                d="m12.46,26.35h12.8c.52,0,.95-.43.95-.95v-12.8c0-.52-.43-.95-.95-.95h-12.8c-.52,0-.95.43-.95.95v12.8c0,.52.43.95.95.95Zm.95-1.9v-10.9h10.9v10.9h-10.9Z"/>
          <path className={pathClass}
                d="m11.86,5.4c.52,0,.95-.43.95-.95V.95c0-.52-.43-.95-.95-.95s-.95.43-.95.95v3.5c0,.52.43.95.95.95Z"/>
          <path className={pathClass}
                d="m16.53,5.4c.52,0,.95-.43.95-.95V.95c0-.52-.43-.95-.95-.95s-.95.43-.95.95v3.5c0,.52.43.95.95.95Z"/>
          <path className={pathClass}
                d="m21.34,5.4c.52,0,.95-.43.95-.95V.95c0-.52-.43-.95-.95-.95s-.95.43-.95.95v3.5c0,.52.43.95.95.95Z"/>
          <path className={pathClass}
                d="m25.97,5.4c.52,0,.95-.43.95-.95V.95c0-.52-.43-.95-.95-.95s-.95.43-.95.95v3.5c0,.52.43.95.95.95Z"/>
          <path className={pathClass}
                d="m5.4,26.06c0-.52-.43-.95-.95-.95H.95c-.52,0-.95.43-.95.95s.43.95.95.95h3.5c.52,0,.95-.43.95-.95Z"/>
          <path className={pathClass}
                d="m.95,22.34h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95H.95c-.52,0-.95.43-.95.95s.43.95.95.95Z"/>
          <path className={pathClass}
                d="m.95,17.53h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95H.95c-.52,0-.95.43-.95.95s.43.95.95.95Z"/>
          <path className={pathClass}
                d="m.95,12.9h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95H.95c-.52,0-.95.43-.95.95s.43.95.95.95Z"/>
          <path className={pathClass}
                d="m37.06,25.11h-3.5c-.52,0-.95.43-.95.95s.43.95.95.95h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95Z"/>
          <path className={pathClass}
                d="m37.06,20.44h-3.5c-.52,0-.95.43-.95.95s.43.95.95.95h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95Z"/>
          <path className={pathClass}
                d="m37.06,15.64h-3.5c-.52,0-.95.43-.95.95s.43.95.95.95h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95Z"/>
          <path className={pathClass}
                d="m33.55,12.9h3.5c.52,0,.95-.43.95-.95s-.43-.95-.95-.95h-3.5c-.52,0-.95.43-.95.95s.43.95.95.95Z"/>
          <path className={pathClass}
                d="m20,44.3v-10.62c0-.61-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1v10.62c-1.4.47-2.42,1.78-2.42,3.33,0,1.94,1.58,3.53,3.53,3.53s3.53-1.58,3.53-3.53c0-1.56-1.02-2.87-2.42-3.33Zm.22,3.33c0,.73-.59,1.32-1.32,1.32s-1.32-.59-1.32-1.32.59-1.32,1.32-1.32,1.32.59,1.32,1.32Z"/>
          <path className={pathClass}
                d="m30.41,39.35c-1.56,0-2.87,1.02-3.33,2.42h-2.5v-7.98c0-.61-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1v9.08c0,.61.5,1.1,1.1,1.1h3.6c.47,1.4,1.78,2.42,3.33,2.42,1.94,0,3.53-1.58,3.53-3.53s-1.58-3.53-3.53-3.53Zm0,4.85c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32Z"/>
          <path className={pathClass}
                d="m15.52,33.53c0-.61-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1v6.64h-3.49c-.47-1.4-1.78-2.42-3.33-2.42-1.94,0-3.53,1.58-3.53,3.53s1.58,3.53,3.53,3.53c1.56,0,2.87-1.02,3.33-2.42h4.59c.61,0,1.1-.5,1.1-1.1v-7.74Zm-7.71,7.74c0,.73-.59,1.32-1.32,1.32s-1.32-.59-1.32-1.32.59-1.32,1.32-1.32,1.32.59,1.32,1.32Z"/>
        </g>
      </g>
    </svg>
  );
}

export default CPUNodes1;
